import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsNextdoorAds = {
  show: async(props) => {
    const { default: NextdoorAdsSettings } = await import('@/vue_widgets/mlap/settings/nextdoor_ads/index.vue')
    createVueApp(NextdoorAdsSettings, { props, sidebar })
  }
}
